import { render } from "./KycFailed.vue?vue&type=template&id=06a4b324&lang=true"
import script from "./KycFailed.vue?vue&type=script&lang=js"
export * from "./KycFailed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__